import { useMemo, useState } from "react";
import { ArrowUp, ArrowDown, ArrowUpDown } from "lucide-react";

const collator = new Intl.Collator("id", { numeric: true, sensitivity: "base" });
const memory = {}; // urutan diingat selama tab terbuka (navigasi SPA), hilang saat reload

function cmp(a, b) {
  const na = a == null || a === "", nb = b == null || b === "";
  if (na || nb) return na === nb ? 0 : na ? 1 : -1;
  return typeof a === "number" && typeof b === "number" ? a - b : collator.compare(String(a), String(b));
}

// getters: { kolom: (row) => nilai }. Klik: naik → turun → bawaan.
export function useTableSort(key, rows, getters) {
  const [sort, setSortState] = useState(memory[key] || null);
  const setSort = (s) => { memory[key] = s; setSortState(s); };
  const toggle = (col) => setSort(sort?.col !== col ? { col, dir: "asc" } : sort.dir === "asc" ? { col, dir: "desc" } : null);
  const sorted = useMemo(() => {
    if (!rows || !sort || !getters[sort.col]) return rows;
    const g = getters[sort.col], m = sort.dir === "asc" ? 1 : -1;
    return [...rows].sort((a, b) => {
      const va = g(a), vb = g(b);
      const empty = (v) => v == null || v === "";
      if (empty(va) || empty(vb)) return cmp(va, vb);
      return m * cmp(va, vb);
    });
  }, [rows, sort, getters]);
  return { sorted, sort, toggle, setSort };
}

export function SortTh({ col, label, s, testid, className = "" }) {
  const active = s.sort?.col === col;
  const Icon = !active ? ArrowUpDown : s.sort.dir === "asc" ? ArrowUp : ArrowDown;
  return (
    <th className={className} aria-sort={active ? (s.sort.dir === "asc" ? "ascending" : "descending") : "none"}>
      <button type="button" onClick={() => s.toggle(col)} data-testid={`${testid}-sort-${col}`}
              className={`inline-flex items-center gap-1 uppercase hover:text-[#111827] ${active ? "text-[#0055FF]" : ""}`}>
        {label}<Icon className={`h-3 w-3 ${active ? "" : "opacity-40"}`} />
      </button>
    </th>
  );
}
